import config from '../config';

export const paramsToObject = params => {
  const object = Object.fromEntries(params);

  return Object
    .entries(object)
    .reduce((acc, [key]) => {
      return {
        ...acc,
        [key]: params.getAll(key)
      };
    }, {});
};

export const isDefaultLocation = location => {
  return Boolean(
    location.lat === config.googleMapsDefaultCenter.lat &&
    location.lng === config.googleMapsDefaultCenter.lng
  );
};

export const getInitialCenter = filters => {
  return (filters.lat && filters.lng)
    ? {
      lat: Number(filters.lat[0]),
      lng: Number(filters.lng[0]),
      ...(filters.q && {
        q: filters.q[0]
      }),
      ...(filters.name && {
        name: filters.name[0]
      })
    }
    : config.googleMapsDefaultCenter;
};

export const getSpotsWithDistance = (spots, geolocation) => {
  return spots
    .map(spot => {
      if (geolocation.longitude && geolocation.latitude) {
        const metersDistance = window.google.maps.geometry.spherical.computeDistanceBetween(
          new window.google.maps.LatLng(geolocation.latitude, geolocation.longitude),
          new window.google.maps.LatLng(spot.location.coordinates[1], spot.location.coordinates[0])
        );

        const kilometersDistance = parseFloat((metersDistance / 1000).toFixed(1));

        return {
          ...spot,
          distance: kilometersDistance
        };
      }

      return spot;
    })
    .filter(Boolean);
};

export const orderSpotsByDistance = spotsWithDistance => spotsWithDistance.sort((a, b) => {
  return a.distance - b.distance;
});

export const orderSpotsByTierDistance = spotsWithDistance => {
  const badgedSpots = spotsWithDistance
    .filter(spot => spot.badge && spot.badge.name.toUpperCase() !== 'BRONS')
    .sort((a, b) => {
      // Uncomment to place all "GULD" on top
      // if (a.badge.name.toUpperCase() === 'GULD') {
      //   return -1;
      // }
      // if (a.badge.name.toUpperCase() === 'SILVER') {
      //   return 1;
      // }
      return a.distance - b.distance;
    });

  const unbadgedSpots = spotsWithDistance
    .filter(spot => !spot.badge)
    .sort((a, b) => a.distance - b.distance);

  return [
    ...badgedSpots,
    ...unbadgedSpots
  ];
};

export const orderSpotsByName = spotsWithDistance => spotsWithDistance.sort((a, b) => {
  const nameA = a?.user?.name;
  const nameB = b?.user?.name;

  if (nameA < nameB) {
    return -1;
  }

  if (nameA > nameB) {
    return 1;
  }

  return 0;
});

export const normalizePlaceholder = (placeholder, query) => {
  return placeholder.startsWith((query[0] || '').toUpperCase() + query.slice(1)) ? placeholder : '';
};

export const includedInTier = (field, spot) => {
  if (!config.tierDependentSpotData) return true;
  const tier = spot?.badge?.name;

  if (!tier) {
    if (field === 'description') return false;
    if (field === 'address') return false;
    if (field === 'website') return false;
    if (field === 'avatar') return false;
  }

  if (tier.toLowerCase() === 'silver') {
    if (field === 'description') return true;
    if (field === 'address') return true;
    if (field === 'website') return true;
    if (field === 'avatar') return false;
  }

  if (tier.toLowerCase() === 'guld') {
    if (field === 'description') return true;
    if (field === 'address') return true;
    if (field === 'website') return true;
    if (field === 'avatar') return true;
  }
};

export const getShortDescription = spot => {
  const [shortDescription] = (spot.address_line_1 ? spot.address_line_1 : '').split('\n');
  return shortDescription;
};

export const getStyleHack = () => <style>
  {`
input[type=email],input[type=text] {
  color: unset;
  border: unset;
  border-radius: unset;
  -webkit-appearance: unset;
  padding: unset;
  height: unset;
  border-width: unset;
  border-style: unset;
  border-color: unset;
  border-radius: unset;
  background: unset;
  box-shadow: unset;
  box-sizing: unset;
  transition: unset;
  border-color: unset;
  box-shadow: unset;
}

.MuiToggleButton-root, 
.MuiToggleButton-root:hover, 
.MuiToggleButton-root:active,
.MuiToggleButton-root:focus {
  color: unset;
  background-color: unset;
  border: 1px solid rgba(0, 0, 0, 0.12);
  overflow: unset;
}
.MuiToggleButton-root:hover,
.MuiToggleButton-root:active,
.MuiToggleButton-root:focus {
  background-color: rgba(0, 0, 0, 0.04);
}
`}
</style>;
